import type { CouponIdentifiers, CouponType } from '../../../../schema/coupon/entry.js';
import type { DrawNumber } from '../../../../schema/draw/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';
import type { ICreateCouponUseCase } from '../../../domain/entry.js';

export type ICreateCouponController = ReturnType<typeof createCouponController>;

type ControllerArgs = {
  payload: {
    itsProduct: Definition['drawProducts'][number];
    couponType: CouponType;
    drawNumber: DrawNumber;
    eventCount: number;
    betAmount?: number;
  };
};

/**
 * Controller for creating a coupon.
 *
 * @param createCouponUseCase Use case for creating a coupon
 * @returns Controller executor function
 */
export function createCouponController(createCouponUseCase: ICreateCouponUseCase) {
  return async function controller({
    payload: { itsProduct, couponType, drawNumber, eventCount, betAmount },
  }: ControllerArgs): Promise<CouponIdentifiers> {
    // TODO: [CA]: here we would like to validate if the draw is still opened and throw error if not
    return createCouponUseCase.execute({ itsProduct, couponType, drawNumber, eventCount, betAmount });
  };
}
